"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconRenewable = function IconRenewable(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "m10.39 28.75-2.409.38c2.416 7.09 8.866 12.18 16.016 12.18A17.36 17.36 0 0 0 40.95 27.472l.068-.345 1.966.366C41.28 36.642 33.31 43.284 24 43.31c-8.16 0-15.432-5.824-18.023-13.863L3.5 29.84 6 23.33zM24.5 22.5 29 22l-7 11 1.5-7.5-4.5.5 7-11zM22.8 5.37a19.16 19.16 0 0 1 19.181 12.836l2.479-.406L42 24.33l-4.42-5.4 2.396-.394A17.16 17.16 0 0 0 7.05 21.173l-.066.35-1.968-.346A19.16 19.16 0 0 1 22.8 5.369"
  })));
};

export { IconRenewable, IconRenewable as default };
